export const decodeIframeString = (str: string): string => {
  const fallbackPoster = 'https://www.foxhuntgames.com/fallback-thumbnail.jpg' // your backup image
  const posterOffset = 'so_7' // Cloudinary poster frame offset

  // Step 1: Join scattered encoded video tags (split in <p> by rich editors)
  const joined = str
    .replace(/<p>(&lt;\/?(video|source)[^&]*?&gt;)<\/p>/gi, '$1') // unwrap <video> and <source>
    .replace(/<p>\s*(&nbsp;)?([^<]*?)<\/p>/gi, '$2') // unwrap inner lines
    .replace(/\s*\n\s*/g, '') // remove newlines

  // Step 2: Decode entities
  let decoded = joined
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')

  // Step 3: Inject poster into decoded <video> blocks
  decoded = decoded.replace(
    /<video([^>]*?)>\s*<source\s+src="([^"]+)"\s+type="video\/mp4"\s*\/?>/gi,
    (_match, attrs, src) => {
      const posterUrl = src.includes('/upload/')
        ? src
            .replace('/upload/', `/upload/${posterOffset}/`)
            .replace('.mp4', '.jpg')
        : fallbackPoster

      return `<video${attrs} poster="${posterUrl}"><source src="${src}" type="video/mp4" />`
    },
  )

  return decoded
}
